<mat-toolbar color="primary" class="main-toolbar" [class.handset]="(isHandset$ | async)">
  <div class="toolbar-content">

    @if (loginReady && (loginState$ | async) && (isHandset$ | async)) {
      <button mat-icon-button (click)="menuToggle.emit()"
        aria-label="Open menu">
        <mat-icon>menu</mat-icon>
      </button>
    }

    @if (!(isHandset$ | async)) {
      <a href="/" class="logo" [routerLink]="['/']">
        <img src="assets/images/raksainfo_white_clear.png" alt="RaksaInfo Logo" width="192" height="48">
      </a>
    }
    @if (isHandset$ | async) {
      <a href="/" class="logo-mobile" [routerLink]="['/']">
        <img src="assets/images/raksainfo_white_clear.png" alt="RaksaInfo" class="logo-mobile-img" height="26">
      </a>
    }

    @if (!(isHandset$ | async)) {
      @for (link of navLinks; track link) {
        <button mat-button
          [routerLink]="link.path"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{exact: true}">
          <mat-icon>{{ link.icon }}</mat-icon> {{ link.label | translate }}
        </button>
      }
      <!-- Mirrors the guard on projects/:id/calendar/month. Ungated this link sent every
      user without either right straight from the toolbar to /unauthorized. -->
      <button mat-button
        *hasPermission="[permissions.UserPermissions.CanSeeCalendar, permissions.CanViewArrivalsList]"
        [routerLink]="['projects', selectedProject$ | async, 'calendar', 'month']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{exact: true}">
        <mat-icon>calendar_month</mat-icon> {{ "Calendar" | translate }}
      </button>
    }

    <span class="example-spacer"></span>

    <!-- Unread announcements. Deliberately NOT inside the `!(isHandset$ | async)`
         groups below: on a handset this toolbar is only the menu button and the logo,
         and the person most likely to miss an announcement is exactly the one working
         from a bookmarked deep link on a phone. Gated on loginReady so it neither
         flashes nor fires an API call while auth is still bootstrapping. -->
    <button mat-icon-button
      *ngIf="loginReady && (loginState$ | async)"
      class="announcement-bell"
      [routerLink]="['/announcements/my']"
      [matTooltip]="'ANNOUNCEMENTS.INBOX_TITLE' | translate"
      [attr.aria-label]="'ANNOUNCEMENTS.INBOX_TITLE' | translate">
      <mat-icon class="toolbar-icon"
        [class.has-unread]="hasAttention$ | async"
        [matBadge]="attentionCount$ | async"
        matBadgeColor="warn"
        matBadgeSize="small"
        [matBadgeHidden]="!(hasAttention$ | async)"
        [matBadgeDescription]="bellBadgeDescription$ | async">campaign</mat-icon>
    </button>

    <!-- Auth in progress: skeleton placeholders -->
    @if (!loginReady && !(isHandset$ | async)) {
      <div class="toolbar-skeleton">
        <div class="skeleton-block wide"></div>
        <div class="skeleton-block narrow"></div>
      </div>
    }

    @if (loginReady && !(isHandset$ | async) && (loginState$ | async)) {
      <div class="user-info" appFlyIn>
        <div class="debug-pill" *hasPermission="permissions.CanSeeDebugInfo" [class.debug-on]="showDebug">
          <mat-slide-toggle
            [(ngModel)]="showDebug"
            color="warn"
            (change)="toggleDebugMode($event)">
            <span class="debug-label">
              <mat-icon class="debug-icon">bug_report</mat-icon>
              <span>Debug</span>
            </span>
          </mat-slide-toggle>
        </div>
        <ri-toolbar-project-selector
          [selectedProject]="selectedProject$ | async"
          [projects]="projects"
          [showLoading]="(projectsLoading$ | async) || false"
          (selectedProjectChange)="changeProject($event)">
        </ri-toolbar-project-selector>
        <button mat-button class="user-btn" [matMenuTriggerFor]="userMenu">
          <span class="btn-content">
            <span class="user-avatar">{{ username.charAt(0).toUpperCase() }}</span>
            <span class="user-name">{{ username }}</span>
            <mat-icon class="chevron">expand_more</mat-icon>
          </span>
        </button>
      </div>
    }

    @if (loginReady && !(isHandset$ | async) && (loginState$ | async)) {
      <span class="toolbar-divider"> </span>
    }

    @if (!(isHandset$ | async)) {
      <div class="toolbar-icon-group">
        <ri-server-status-indicator
          *hasPermission="permissions.UserPermissions.CanManageUserRoles">
        </ri-server-status-indicator>
        <button mat-icon-button
          *hasPermission="permissions.UserManualPermissions.CanViewUserManual"
          [routerLink]="['/manual']"
          [matTooltip]="'USER_MANUAL.TITLE' | translate"
          aria-label="User Manual">
          <mat-icon class="toolbar-icon">help</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="themeMenu" aria-label="Theme Picker">
          <mat-icon class="toolbar-icon">palette</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="langMenu" aria-label="Language">
          <mat-icon class="fi" [ngClass]="langIcon"></mat-icon>
        </button>
      </div>
    }

    @if (loginReady && !(loginState$ | async)) {
      <button mat-button
        (click)="login()">
        <mat-icon>login</mat-icon> {{ "LOGIN" | translate }}
      </button>
    }

  </div>
</mat-toolbar>
